// Updating the slider values needs to be retrocompatible
export const RADIUS_VALUES = [500, 1000, 2000, 3500, 5000, 10000] as const;

export function radiusValueToIndex(value: number): number {
  const idx = RADIUS_VALUES.indexOf(value as (typeof RADIUS_VALUES)[number]);
  return idx >= 0 ? idx : 0;
}

export function radiusIndexToValue(index: number): (typeof RADIUS_VALUES)[number];
export function radiusIndexToValue(index: number[]): (typeof RADIUS_VALUES)[number];
export function radiusIndexToValue(index: number | number[]): (typeof RADIUS_VALUES)[number] {
  const i = Array.isArray(index) ? index[0] : index;
  return RADIUS_VALUES[i] ?? RADIUS_VALUES[0];
}

export function metersToKilometers(value: number): number {
  return value / 1000;
}

/**
 * Formats a distance value in meters as a human-readable string.
 * Returns values in meters (e.g., "500m") for distances under 1000m,
 * and in kilometers (e.g., "1km") for distances 1000m and above.
 */
export function metersToKilometersString(value: number): string {
  if (value >= 1000) {
    const kilometers = value / 1000;
    return `${kilometers}km`;
  }
  return `${value}m`;
}

/**
 * Calculates appropriate Mapbox zoom levels based on radius values using logarithmic scaling.
 * Smaller radius values result in higher zoom levels (more zoomed in).
 * Larger radius values result in lower zoom levels (more zoomed out).
 * Uses a logarithmic formula for precise scaling across all radius ranges.
 */
export function radiusToZoomLevel(radius: number): number {
  // Handle edge cases
  if (radius <= 0) return 14; // Default zoom level

  // Clamp zoom between Mapbox min (7) and max (22)
  const zoom = 15 - Math.log2(radius / 500);
  return Math.min(22, Math.max(7, zoom));
}
